import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import { logtail } from '@/utils/logtail';
import headerObject from '@/types/headerObj';

const endpoint = apiUrl + 'removeMemberFromOrganization/';

export const removeMemberFromOrganizationRequest = async (
  { UserUUID, OrgUUID }: { UserUUID: string; OrgUUID: string },
  headerObj?: headerObject
) => {
  try {
    const response = await postWithAuth(
      endpoint,
      {
        UserUUID,
        OrgUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.json();
    return JSON.parse(text);
  } catch (error) {
    logtail.error(error + 'error in removeMemberFromOrganization', {
      UserUUID,
      OrgUUID,
    });
    logtail.flush();
    return { Error: 'Failed to remove member from organization' };
  }
};
